import request from '@/utils/request'

/** 业主手工缴费流水（按录入时间） */
export function manualEntryRecordsList(params) {
  return request({ url: '/owner-payment/manual-entry-records/', method: 'get', params })
}
